import styled from 'styled-components'

import AccountPagePanel from 'account/components/AccountPagePanel'
import { AccountQA } from 'shared/dataAttributes'
import { BillingInfo } from 'shared/types/BillingInfo'
import { CardIcon } from 'shared/components/Icons'
import { fonts } from 'shared/lib'
import { t } from 'localization'

const TP = 'account.components.paymentPanel'

type PaymentPanelProps = {
  creditCards?: BillingInfo[]
}

export const PaymentPanel = ({ creditCards }: PaymentPanelProps) => {
  return (
    <PaymentPanelBox qaAttr={AccountQA.Payment} title={t(`${TP}.payment`, 'Payment')}>
      <CreditCards>
        {!!creditCards?.length &&
          creditCards.map(({ cardBrand, id, last4Digits }) => (
            <CreditCard
              data-qa={AccountQA.PaymentContentList}
              data-testid="paymentPanelSavedCards"
              key={id}
            >
              <div>
                {cardBrand} *{last4Digits}
              </div>
              <div>
                <CardIcon brand={cardBrand} width={26} height={16} />
              </div>
            </CreditCard>
          ))}
      </CreditCards>
      {(!creditCards || creditCards.length === 0) && (
        <NoSaved data-qa={AccountQA.PaymentEmptySection} data-testid="paymentPanelEmpty">
          {t(`${TP}.noSavedPayments`, 'No saved payments.')}
        </NoSaved>
      )}
    </PaymentPanelBox>
  )
}

const CreditCard = styled.div`
  display: flex;
  justify-content: space-between;
  text-transform: uppercase;
  &:not(:last-of-type):not(:first-of-type) {
    margin: 15px 0;
  }
`

const NoSaved = styled.div`
  ${fonts.BODY_TEXT}
`

// Adds custom scroll bar and margin to scroll bar
const CreditCards = styled.div`
  overflow-y: auto;
  /* tslint:disable-next-line:max-line-length */
  /* https://stackoverflow.com/questions/21684101/css-vertical-scrollbar-padding-left-right-in-ul-possible */
  ::-webkit-scrollbar {
    width: 14px;
    height: 18px;
  }
  ::-webkit-scrollbar-thumb {
    height: 6px;
    border: 4px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    /* stylelint-disable property-no-vendor-prefix */
    -webkit-border-radius: 7px;
    background-color: rgba(0, 0, 0, 0.15);
    -webkit-box-shadow: inset -1px -1px 0px rgba(0, 0, 0, 0.05),
      inset 1px 1px 0px rgba(0, 0, 0, 0.05);
  }
  ::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }
  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }
`

const PaymentPanelBox = styled(AccountPagePanel)`
  display: flex;
  flex-direction: column;
  max-height: 172px;
`
